export default {
  description: function description(state) {
    return state.description;
  },
  products: function products(state) {
    return state.products;
  },
  productsCount: function productsCount(state) {
    return state.total;
  }
};